import { useQuery } from "@tanstack/react-query"

import { v1GetRideSummary } from "@be-miniapp/api"

interface TransportEngagementDetailQueryData {
  data: {
    engagementid: string
    sessionid: string
  }
}

const transportEngagementDetailQueryKey = {
  all: ["transport-engagement-detail"] as const,
  engagementid: (engagementid: string | undefined) => [
    ...transportEngagementDetailQueryKey.all,
    engagementid,
  ],
}

export function useTransportEngagementDetail({
  data: { engagementid, sessionid },
}: TransportEngagementDetailQueryData) {
  return useQuery({
    queryKey: transportEngagementDetailQueryKey.engagementid(engagementid),
    queryFn: async () => {
      return v1GetRideSummary({
        engagement_id: engagementid || "",
        session_id: sessionid || "",
        order_history: 0,
        show_right_menu: 1,
      })
    },
    staleTime: 0,
    refetchOnWindowFocus: false,
  })
}
